﻿import Vue from "vue";
import Component from "vue-class-component"
import HotEditableFormManager_ from "./hotEditable/HotEditableFormManager";
import common from "../../common";
import SharedFormManager_ from "./hotEditable/SharedFormManager";
import HotEditableFormLoader_ from "./hotEditable/HotEditableFormLoader";


declare function require(module: string): unknown;
// const HotEditableFormManager = require("./hotEditable/HotEditableFormManager") as HotEditableFormManager_;
// const SharedFormManager = require("./hotEditable/SharedFormManager") as SharedFormManager_;
// const HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader") as HotEditableFormLoader_;

// The @Component decorator indicates the class is a Vue component
@Component
class PanneauAdministrationVue extends Vue implements common.IHotEditableFormVue {
    $initialData: any;

    shared?: SharedFormManager_;
    formMode = common.HotEditableFormModes.original;
    formManager?: HotEditableFormManager_ | null;

    // Statut de la synchro
    synchroStatusCode = null as string | null;
    synchroStatusDescription = null as string | null;
    synchroStatusIndicator = null as string | null;
    synchroSteps = [] as string[];
    maximumStepsToShow = 5;

    // Statut de la cache des fermes
    isFermeCacheReady = false;
    fermeCacheStatusDescription = null as string | null;
    fermeCacheReadyIndicator = null as string | null;

    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;
        HotEditableFormLoader_.prepareComponentsMarkupFromTarget(true, false, rootId).loadComponentsFromParent(this);

        this.$options.el = '#' + rootId;

        this.formManager = new HotEditableFormManager_(this, (this as any).$initialData.formName as string | null);
        this.shared = new SharedFormManager_(this.formManager);
    }

    created() { }

    mounted() {
        for (let i = 0; i < this.maximumStepsToShow; i++)
            this.synchroSteps.push("");
    }

    // Défini le statut de la synchro à l'écran
    setSynchroStatus(code: string, description: string, currentStep: string) {
        this.synchroStatusCode = code;
        this.synchroStatusDescription = description;

        // Définir la couleur de l'indicateur
        if (code === common.TaskStatus.ok)
            this.synchroStatusIndicator = common.IndicatorStatus.ok;
        else if (code === common.TaskStatus.running || code === common.TaskStatus.runningLong)
            this.synchroStatusIndicator = common.IndicatorStatus.warning;
        else if (code === common.TaskStatus.inError || code === common.TaskStatus.jammed)
            this.synchroStatusIndicator = common.IndicatorStatus.error;
        else
            this.synchroStatusIndicator = common.IndicatorStatus.default;

        // Ajouter à l'écran le "step" courant de la synchro s'il est différent du dernier obtenu

        // Si le plus recent doit etre en dernier...
        // if (currentStep && currentStep !== this.synchroSteps[this.synchroSteps.length - 1]) {
        //     this.synchroSteps.push(currentStep);
        //     this.synchroSteps.shift();
        // }
        // Si le plus recent doit etre en premier...
        if (currentStep && currentStep !== this.synchroSteps[0]) {
            this.synchroSteps.splice(0, 0, currentStep);
            this.synchroSteps.pop();
        }
    }

    //------------------------------------------------------------------
    // Défini le statut de la cache des fermes à l'écran
    //------------------------------------------------------------------
    setFermeCacheStatus(isReady: boolean, description: string) {
        this.isFermeCacheReady = isReady;
        this.fermeCacheStatusDescription = description;

        // Définir la couleur de l'indicateur
        this.fermeCacheReadyIndicator = isReady
            ? common.IndicatorStatus.ok
            : common.IndicatorStatus.warning;
    }
}

export = PanneauAdministrationVue;